<template>
  <section class="scan-wrapper">
    <header class="scan-header">
      <router-link class="logo-link" to="/" aria-label="На главную">
        <img src="@/assets/images/logo.svg" alt="АИС РМЛ РАС">
      </router-link>
    </header>

    <main class="scan-content">
      <slot/>
    </main>
  </section>
</template>

<script>
export default {
  name: "ScanLayout",
};
</script>

<style scoped lang="scss">
@import '/src/assets/theme/default/colors.scss';

.scan-wrapper {
  min-height: 100vh;
  background-color: $white;
}

.scan-header {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
}

.logo-link {
  display: inline-flex;
  align-items: center;
}

.logo-link img {
  display: block;
  max-height: 64px;
}

.scan-content {
  max-width: 760px;
  margin: 0 auto;
  padding: 56px 20px;
}
</style>
